import React, { useMemo, useState, useEffect } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { MutateSetActiveImportIDs } from "../../../utils/graphql/hooks/importsHooks";
import toast from "react-hot-toast";

export default function SaveImportsBar() {
  const [showConfirm, setShowConfirm] = useState(false);

  const importPreviews = useSelector(
    (state: RootState) => state.imports?.importPreviews,
    isEqual,
  );
  const imports = useSelector(
    (state: RootState) => state.imports.imports,
    isEqual,
  );

  useEffect(() => {
    setShowConfirm(false);
  }, [importPreviews]);

  const hasUnsavedChanges = useMemo(() => {
    if (!imports || !importPreviews) return false;

    return Object.keys(imports).some((importType) => {
      const importItem = imports[importType as keyof typeof imports];
      const preview = importPreviews[importType as keyof typeof importPreviews];
      return importItem?._id !== preview?._id;
    });
  }, [imports, importPreviews]);

  const saveImports = MutateSetActiveImportIDs();

  const handleSaveImports = async () => {
    try {
      const result = await saveImports({
        variables: {
          activeImportIDs: {
            em: importPreviews?.em?._id || null,
            strategy: importPreviews?.strategy?._id || null,
            encryption: importPreviews?.encryption?._id || null,
          },
        },
      });

      if (result.data?.setActiveImportIDs) {
        toast.success("Imports saved successfully!");
      }
    } catch (error) {
      console.error(error);
    }
    setShowConfirm(false);
  };

  return (
    <div className={styles.container}>
      {showConfirm ? (
        <div className={styles.confirmationOverlay}>
          Are you sure? This will also reset the AKS Dashboard.
          <div className={styles.confirmationButtons}>
            <button
              className={styles.confirmButton}
              onClick={handleSaveImports}
            >
              Yes
            </button>
            <button
              className={styles.confirmButton}
              onClick={() => setShowConfirm(false)}
            >
              No
            </button>
          </div>
        </div>
      ) : (
        <>
          {hasUnsavedChanges ? (
            <div className={styles.warning}>NOT SAVED</div>
          ) : (
            <div className={styles.saved}>SAVED</div>
          )}
          <button
            className={styles.saveButton}
            onClick={() => setShowConfirm(true)}
          >
            Save Imports
          </button>
        </>
      )}
    </div>
  );
}
